import axios from "axios";

let cached = null;
let pending = null;

function usable(settings) {
  return Boolean(settings && (settings.storeName || settings.logoUrl || settings.supportEmail));
}

export function peekStoreSettings() {
  if (usable(cached)) return cached;
  if (typeof window !== "undefined" && usable(window.__ECOM_STORE_SETTINGS__)) {
    cached = window.__ECOM_STORE_SETTINGS__;
    return cached;
  }
  return null;
}

export function rememberStoreSettings(settings) {
  if (!usable(settings)) return;
  cached = settings;
  if (typeof window === "undefined") return;
  window.__ECOM_STORE_SETTINGS__ = settings;
  try {
    localStorage.setItem("store_settings", JSON.stringify(settings));
  } catch (e) {}
}

function fetchSettings() {
  pending = axios
    .get("/api/settings")
    .then((res) => {
      if (res.data && res.data.status === 200 && usable(res.data.settings)) {
        rememberStoreSettings(res.data.settings);
        return res.data.settings;
      }
      return peekStoreSettings() || {};
    })
    .catch(() => peekStoreSettings() || {})
    .finally(() => {
      pending = null;
    });
  return pending;
}

export function loadStoreSettings() {
  const ready = peekStoreSettings();
  if (ready) return Promise.resolve(ready);
  if (pending) return pending;
  if (typeof window !== "undefined" && window.__ECOM_SETTINGS_PROMISE__) {
    pending = Promise.resolve(window.__ECOM_SETTINGS_PROMISE__)
      .then((settings) => {
        if (usable(settings)) {
          rememberStoreSettings(settings);
          return settings;
        }
        pending = null;
        return fetchSettings();
      })
      .finally(() => {
        pending = null;
      });
    return pending;
  }
  return fetchSettings();
}
